import { sanitizeUrl } from '@braintree/sanitize-url';
import Link from '@mui/material/Link';
import MenuItem from '@mui/material/MenuItem';
import type { RouterProps} from 'common/utilities/withRouter/withRouter';
import {withRouter } from 'common/utilities/withRouter/withRouter';
import * as I from 'core/api/coreApiClient';
import CommandLinkContent from 'core/components/Elements/Command/CommandLinkContent/CommandLinkContent';
import type { ItemComponentProps} from 'core/components/Elements/DropDown/DropDown';
import { menuItemStyles } from 'core/components/Elements/DropDown/DropDown';
import type { ApplicationState } from 'core/redux/reducers/rootReducer';
import { formatCommandUrl, isCommandForReactRouter } from 'core/utilities/command/command';
import type React from 'react';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';

type ComponentProps = ItemComponentProps & RouterProps;

function ItemLink({
  item, buttonRef, onClose, selected,
}: ComponentProps) {
  const {
    id, title, active, commandType,
  } = item;
  const jsfUrl = useSelector((state: ApplicationState) => state.configuration.jsfUrl);
  const formattedUrl = formatCommandUrl(jsfUrl, item);
  const isReactRouterLink = isCommandForReactRouter(item);

  return (
    <li role="menuitem" title={title} aria-disabled={active === false}>
      <MenuItem
        data-e2e-dropdown-item={id}
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          onClose(e, buttonRef);
        }}
        to={isReactRouterLink ? sanitizeUrl(formattedUrl) : undefined}
        href={isReactRouterLink ? undefined : formattedUrl}
        target={!isReactRouterLink && commandType !== I.CommandTypeConstants.JSFHREF ? '_blank' : '_self'}
        component={isReactRouterLink ? RouterLink : Link}
        role="link"
        dense
        disabled={active === false}
        sx={menuItemStyles}
        selected={selected}
      >
        <CommandLinkContent command={item} />
      </MenuItem>
    </li>
  );
}

export default withRouter<ComponentProps>(ItemLink);
